import { type CardConstructor } from '../../entities/Card'
import { type CardApiModel } from '../api-models/CardApiModel'

export const mapCardApiModel = (card: CardApiModel): CardConstructor => ({
  id: card.id,
  externalId: card.external_id,
  last4Digits: card.number,
  type: card.category,
  status: card.status,
  cardholder: {
    id: card.cardholder.id,
    firstName: card.cardholder.first_name,
    lastName: card.cardholder.last_name,
    email: card.cardholder.email,
    profileImage: card.cardholder.profile_image,
    secondaryCategoryId: card.cardholder.department_id,
    tosAccepted: card.cardholder.tos_accepted,
    externalId: card.cardholder.external_id,
    userId: card.cardholder.user_id,
    provider: card.cardholder.provider,
  },
  createdAt: card.created_at,
  updatedAt: card.updated_at,
  requireActivation: card.require_activation,
})
